import { useQuery } from "@tanstack/react-query";
import { sendAjaxRequest } from "@/ts/api/comunicacion";
import { Loading, QueryError } from "@/components/Loading/Loading";

export function FiltroCiclos(props: { readonly filtroCiclo: string | null; readonly setFiltroCiclo: (value: string | null) => void; }) {
	function cicloPrioridadToString(id: number): string {
		switch (id) {
			case 1: return "Tiempo Real";
			case 2: return "Alta";
			case 3: return "Normal";
			case 4: return "Menor";
			case 5: return "Baja";
			default: return "Desconocido";
		}
		return "Desconocido";
	}

	const { data, error, isPending } = useCiclosLanzados();

	if (error) return <QueryError error={error} fallback="Error al cargar los ciclos lanzados" />;
	if (isPending) return <Loading />;

	return (
		<div style={{ padding: 30, display: "flex" }}>
			<label style={{ fontSize: 17, marginTop: 6, marginRight: 5 }}>Ciclos: </label>
			<select className="form-control" value={props.filtroCiclo ?? ""} onChange={event => { props.setFiltroCiclo(event.target.value || null); }}>
				<option value="">Sin Filtrar</option>
				{data.map((linea) => (
					<option key={linea.id} value={linea.id}>{linea.id} - Prioridad {cicloPrioridadToString(linea.prioridad)}</option>
				))}
			</select>
		</div>
	);
}
function useCiclosLanzados() {
	return useQuery<CicloLanzado[]>({
		queryKey: ["getCiclosLanzados"],
		queryFn: () => sendAjaxRequest<CicloLanzado[]>("GET", "/api/v1/getCiclosLanzados"),
	});
}
interface CicloLanzado {
	id: number,
	prioridad: number;
}
